export class DadosModal<T> {
  tituloModal: string;
  tamanhoModal: TamanhoModal;
  objeto?: T;

  constructor(dadosModal: DadosModal<T>) {
    this.tituloModal = dadosModal.tituloModal;
    this.tamanhoModal = dadosModal.tamanhoModal;
    this.objeto = dadosModal.objeto;
  }
}


type TamanhoModal = 'small' | 'medium' | 'large';
